import requests from "./httpService";

const LoginService = {
  loginAdmin(body) {
    return requests.post(`/user/login`, body);
  },
};

export default LoginService;
